import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmb { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '帳號代號 (MB001) 不可空白'}) 
    @MaxLength(6,{message: '帳號代號 (MB001) 資料太長'})
    MB001: string = '';            // 帳號代號 6 

    @MaxLength(20,{message: '帳號 (MB002) 資料太長'})
    MB002: string = '';            // 帳號 20 

    @MaxLength(10,{message: '帳戶名稱 (MB003) 資料太長'})
    MB003: string = '';            // 帳戶名稱 10 

    @MaxLength(10,{message: '銀行代號 (MB004) 資料太長'})
    MB004: string = '';            // 銀行代號 10 join  NOT.MA001

    @MaxLength(20,{message: '電話1 (MB005) 資料太長'})
    MB005: string = '';            // 電話1 20 

    @MaxLength(20,{message: '手機 (MB006) 資料太長'})
    MB006: string = '';            // 手機 20 

    @MaxLength(255,{message: '備註 (MB007) 資料太長'})
    MB007: string = '';            // 備註 255 

    @MaxLength(4,{message: '現行年度 (MB008) 資料太長'})
    MB008: string = '';            // 現行年度 4 

    @MaxLength(2,{message: '現行月份 (MB009) 資料太長'})
    MB009: string = '';            // 現行月份 2 

    @IsNumber() 
    MB010: number = 0;            // 本年期初損益 8 

    @IsNumber() 
    MB011: number = 0;            // 本年損益 8 

    @IsNumber() 
    MB012: number = 0;            // 本月損益 8 

    @IsNumber() 
    MB013: number = 20;            // 單筆最低手續費 8 [DEF:20]

    @IsNumber() 
    MB014: number = 0.001425;            // 手續費 10.6 [DEF:0.001425]

    @IsNumber() 
    MB015: number = 0.001425;            // 折扣手續費 10.6 [DEF:0.001425]

    @MaxLength(10,{message: '使用者代號 (MB016) 資料太長'})
    MB016: string = '';            // 使用者代號 10 身分證號?

    @MaxLength(10,{message: '身分證號 (MB017) 資料太長'})
    MB017: string = '';            // 身分證號 10 

    @MaxLength(6,{message: '分類 (MB018) 資料太長'})
    MB018: string = '';            // 分類 6 股票 期貨 海期

    @MaxLength(1,{message: '通知方式 (MB020) 資料太長'})
    MB020: string = '';            // 通知方式 1 020~029 技術分析用

    @MaxLength(20,{message: '通知參數1 (MB021) 資料太長'})
    MB021: string = '';            // 通知參數1 20 

    @MaxLength(100,{message: '參數2 (MB022) 資料太長'})
    MB022: string = '';            // 參數2 100 

    @MaxLength(100,{message: '參數3 (MB023) 資料太長'})
    MB023: string = '';            // 參數3 100 

    @MaxLength(100,{message: '參數4 (MB024) 資料太長'})
    MB024: string = '';            // 參數4 100 

    @MaxLength(300,{message: '通知內容 (MB025) 資料太長'})
    MB025: string = '';            // 通知內容 300 

    MB026: string = '';            // 過濾SQL 0 


}
